export const transformPolygonData = (data) => {
    let arr = [];
    if(data?.polygon && data?.polygon?.edges) {
        for (const value of Object.values(data.polygon.edges)) {
            const obj = [value["pointA"]?.x, value["pointA"]?.y];
            arr = [...arr, obj];
        }
    } else if(data?.polygon && data?.polygon?.polygon && data?.polygon?.polygon?.edges) {
        for (const value of Object.values(data?.polygon?.polygon?.edges)) {
            const obj = [value["pointA"]?.x, value["pointA"]?.y];
            arr = [...arr, obj];
        }
    }
  return arr;
};

export const transformInPolygonData = (data) => {
    let arr = [];
    if(data) {
        for (const value of Object.values(data)) {
            const obj = [value["pointA"]?.x, value["pointA"]?.y];
            arr = [...arr, obj];
        }
    }
    return arr;

}